module.exports = __webpack_public_path__ + "static/media/rydz_nearnew.22f91fd2.jpg";